import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
var _hoisted_1 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_2 = {
  style: {
    "flex": "1"
  }
};
var _hoisted_3 = {
  style: {
    "display": "flex",
    "width": "100%",
    "justify-content": "space-between"
  }
};
var _hoisted_4 = {
  class: "tooltip-star"
};
var _hoisted_5 = ["src"];
var _hoisted_6 = {
  class: "dialog-footer"
};
import { reactive, ref, watch, watchEffect } from "vue";
import { set_clue, sales_area, client, get_clue, get_client_project, getcustomTypeInfo } from "@/api/apis";
import { useUserStore } from "@/store/user";
import { ElMessage } from "element-plus";
import _ from "lodash";
import { useDicStore } from "@/store/dictionary";
import { getTree, de_weight } from "@/util/index";
import { systemType } from "@/constants";
export default {
  __name: 'addClueDailog',
  props: ["id", "isShow", "info", "goods"],
  emits: ["close", "onSetSuccess"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var disStore = useDicStore();
    var props = __props;
    var emit = __emit;
    var userStore = useUserStore();
    var ruleFormRef = ref(null);
    var orderRateList = ref([{
      label: "<30%"
    }, {
      label: "30-60%"
    }, {
      label: "60-90%"
    }, {
      label: ">90%"
    }]);
    var default_client = {
      sale_user: "",
      //销售员
      images: [],
      trade: "",
      //行业
      email: "",
      //联系人邮箱
      company: "",
      phone: "",
      //联系人手机号
      business_type: "1",
      // 类型 默认1=线索 2=商机 3=报价
      title: "",
      // 项目名称
      source: "",
      // 来源
      clent_user_id: "",
      // 联系人
      name: "",
      //联系人姓名
      thread_status: "未处理",
      //线索状态
      address: "",
      // 地址
      country: "",
      remark: "",
      // 备注
      sales_dept_id: "",
      userid: "",
      income: "",
      invalid_reason: "",
      complete_time: "",
      is_client: "",
      activity_name: "",
      client_project_id: null,
      client_level_number: null,
      client_type: null,
      client_type_number: null,
      client_level: null
    };
    var form = ref();
    form.value = Object.assign({}, default_client);
    console.log(form.value);
    var hasValue = ref(false);
    watch(() => {
      return form.value.income;
    }, val => {
      hasValue.value = val > 0 ? true : false;
    });

    /**
     * 关联商品
     */
    var goods_list = ref([]);
    var cate_list = ref([]);
    var goods_list_temp = ref([]);
    var goods_list_temp2 = ref([]);
    watch(() => {
      return props.goods;
    }, val => {
      goods_list.value = _.cloneDeep(val);
      goods_list_temp.value = _.cloneDeep(val);
      goods_list_temp2.value = _.cloneDeep(val);
    });
    var changeSelect = (e, keynumber) => {
      if (keynumber == "client_level") {
        getcustomTypeInfo({
          client_level: e
        }).then(res => {
          if (res.code == 200) {
            var _res$data, _res$data2, _res$data3;
            form.value["client_level_number"] = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.client_level_number;
            form.value["client_type"] = (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.client_type;
            form.value["client_type_number"] = (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.client_type_number;
          }
        });
      } else {
        var _dic_data$clientType_;
        form.value[keynumber] = (_dic_data$clientType_ = dic_data.clientType_list.find(x => x.full_name == e)) === null || _dic_data$clientType_ === void 0 ? void 0 : _dic_data$clientType_.encode;
      }
    };
    var countIncome = data => {
      var total = 0;
      data.map(item => {
        if (item.price) {
          total += parseFloat(item.price);
        }
      });
      form.value.income = parseFloat(total).toFixed(2);
      if (form.value.income == 0) {
        form.value.income = "";
      }
      console.log("income:" + form.value.income);
    };
    watch(() => {
      return goods_list.value;
    }, val => {}, {
      immediate: true
    });
    var handle_goods = val => {
      goods_list.value = val;
      countIncome(val);
    };
    var handle_cate = val => {
      cate_list.value = val;
    };
    var rules = {
      thread_status: [{
        required: "true",
        message: "请选择线索状态",
        trigger: ["blur", "change"]
      }],
      title: [{
        required: "true",
        message: "请输入主题",
        trigger: ["blur", "change"]
      }],
      is_client: [{
        required: "true",
        message: "请选择是否生成客户",
        trigger: ["blur", "change"]
      }],
      client_project_id: [{
        required: "true",
        message: "请选择客户项目",
        trigger: ["blur", "change"]
      }],
      company: [{
        required: "true",
        message: "请输入客户",
        trigger: ["blur", "change"]
      }],
      invalid_reason: [{
        required: "true",
        message: "请选择无效原因",
        trigger: ["blur", "change"]
      }],
      sale_user: [{
        required: "true",
        message: "请设置销售员",
        trigger: ["blur", "change"]
      }],
      sales_dept_id: [{
        required: "true",
        message: "请选择销售区域",
        trigger: ["blur", "change"]
      }],
      name: [{
        required: "true",
        message: "请选择或输入联系人",
        trigger: ["blur", "change"]
      }],
      phone: [{
        required: "true",
        message: "请输入手机号",
        trigger: ["blur", "change"]
      }],
      completion_rate: [{
        validator: (rule, value, callback) => {
          if (form.value.income > 0 && !value) {
            callback(new Error("请选择成单率"));
          } else {
            callback();
          }
        },
        trigger: "blur"
      }],
      complete_time: [{
        required: "true",
        message: "请选择预计完成时间",
        trigger: ["blur", "change"]
      }]
    };

    /**
     * 弹窗的展示与关闭
     */
    var dialogVisible = ref(false);
    var is_show_dialog = ref(false);
    watch(() => {
      return is_show_dialog.value;
    }, val => {
      if (!val) {
        key_word.value = "";
      }
    });
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    watch(() => {
      return dialogVisible.value;
    }, () => {
      if (!dialogVisible.value) {
        form.value = Object.assign({}, default_client);
        fileList.value = [];
        client_contracts_list.value = [];
        dic_data.sales_area_list = []; // 销售区域
        goods_list.value = [];
        cate_list.value = [];
        ruleFormRef.value.resetFields();
        emit("close");
      } else {
        props.info && init_from();
        console.log(props.info);
      }
    });

    // watch(
    //   () => {
    //     return form.value.birthday;
    //   },
    //   (val) => {
    //     console.log("获取的生日是", form.value.birthday);
    //   }
    // );
    /**
     * 上传头像
     */
    var fileList = ref([]);
    var action = process.env.VUE_APP_BASE_URL + "/api/file/add_file";
    var headers = {
      "system-type": systemType,
      Authorization: "Bearer " + localStorage.getItem("token_blk")
    };
    var dialogImageUrl = ref("");
    var dialogVisible_img = ref(false);
    var handleAvatarSuccess = (response, uploadFile) => {
      if (response.code == 200) {
        // form.value.avatar = response.data.file_id;
        // imageUrl.value = response.data.file_url;
      }
    };
    var beforeAvatarUpload = file => {
      var fileType = file.name ? file.name.substring(file.name.lastIndexOf(".") + 1).toUpperCase() : "";
      if (fileType != "JPG" && fileType != "PNG") {
        // ElMessage.error("上传文件只能是JPG或者PNG格式!");
        ElMessage({
          type: "error",
          message: "上传文件只能是JPG或者PNG格式"
        });
      }
      return fileType == "JPG" || fileType == "PNG";
    };
    var handlePictureCardPreview = uploadFile => {
      dialogImageUrl.value = uploadFile.url;
      dialogVisible_img.value = true;
    };
    var handleRemove = (uploadFile, files) => {};
    /**
     * 编辑客户，初始化数据
     */
    var init_from = () => {
      // let obj = _.cloneDeep(props.info);
      get_clue({
        id: props.id
      }).then(res => {
        if (res.code == 200) {
          var _obj$user_info, _obj$user_info2, _obj$client_user_info, _obj$client_user_info2, _obj$client_info, _obj$client_info2, _obj$client_user_info3, _obj$sales_dept_info, _obj$sales_dept_info2, _form$value;
          var obj = props.id == 0 ? props.info : res.data;
          console.log(obj);
          Object.keys(form.value).map(x => {
            if (obj.hasOwnProperty(x) && x != "sales_dept_id") {
              form.value[x] = obj[x];
            }
          });
          console.log(form.value);
          form.value.sale_user = (_obj$user_info = obj.user_info) === null || _obj$user_info === void 0 ? void 0 : _obj$user_info.name;
          form.value.userid = (_obj$user_info2 = obj.user_info) === null || _obj$user_info2 === void 0 ? void 0 : _obj$user_info2.id;
          fileList.value = obj.file_urls;
          form.value["email"] = (_obj$client_user_info = obj.client_user_info) === null || _obj$client_user_info === void 0 ? void 0 : _obj$client_user_info.email;
          form.value["phone"] = (_obj$client_user_info2 = obj.client_user_info) === null || _obj$client_user_info2 === void 0 ? void 0 : _obj$client_user_info2.phone;
          form.value["company"] = (_obj$client_info = obj.client_info) === null || _obj$client_info === void 0 ? void 0 : _obj$client_info.company;
          form.value["trade"] = (_obj$client_info2 = obj.client_info) === null || _obj$client_info2 === void 0 ? void 0 : _obj$client_info2.trade;
          form.value["complete_time"] = (obj === null || obj === void 0 ? void 0 : obj.complete_time) || "";
          form.value["from_road"] = (obj === null || obj === void 0 ? void 0 : obj.from_road) || "";
          form.value["name"] = (_obj$client_user_info3 = obj.client_user_info) === null || _obj$client_user_info3 === void 0 ? void 0 : _obj$client_user_info3.name;
          form.value["is_client"] = obj.is_client;
          form.value["activity_name"] = obj.activity_name;
          form.value["completion_rate"] = obj.completion_rate;
          form.value["client_project_id"] = obj.client_project_id;
          form.value.client_id = obj.client_id;
          form.value["client_type"] = obj.client_info.client_type;
          form.value["client_type_number"] = obj.client_info.client_type_number;
          form.value["client_level"] = obj.client_info.client_level;
          form.value["client_level_number"] = obj.client_info.client_level_number;
          console.log("is_client:" + form.value["is_client"]);
          goods_list.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          goods_list_temp.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          goods_list_temp2.value = _.cloneDeep([...obj.goods_ids_list, ...obj.class_ids_list]);
          form.value.sales_dept_id = Number((obj === null || obj === void 0 || (_obj$sales_dept_info = obj.sales_dept_info) === null || _obj$sales_dept_info === void 0 ? void 0 : _obj$sales_dept_info.id) || "");
          form.value.sales_dept_name = obj === null || obj === void 0 || (_obj$sales_dept_info2 = obj.sales_dept_info) === null || _obj$sales_dept_info2 === void 0 ? void 0 : _obj$sales_dept_info2.name;
          console.log("打印form.value.client_project_id", form.value.client_project_id, form.value.client_id);
          if ((_form$value = form.value) !== null && _form$value !== void 0 && _form$value.client_id) {
            getClientProjects(form.value.client_id);
            cur_client_id.value = form.value.client_id;
          }
          client({
            company: form.value.company
          }).then(data => {
            if (data.code == 200 && form.value.company && data.data.list && data.data.list.length != 0) {
              client_contracts_list.value = data.data.list[0].client_users;
              if (props.id == 0) {
                goods_list.value = _.cloneDeep([...data.data.list[0].goods_ids_list]);
                cate_list.value = _.cloneDeep([...data.data.list[0].class_ids_list]);
              }
            }
          });
        }
      });
    };

    /**
     * 选择客户
     */
    var data_type = ref(""); // 进行选择数据的字段
    var key_word = ref(""); // 关键字查询

    var client_contracts_list = ref([]); // 当前选中客户的联系人列表

    var select_data = val => {
      data_type.value = val;
      is_show_dialog.value = true;
    };
    //获取客户项目
    var client_project_list = ref([]);
    var getClientProjects = function getClientProjects(id) {
      var is_default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      get_client_project({
        client_id: id
      }).then(res => {
        if (res.code == 200) {
          client_project_list.value = res.data || [];
          if (is_default) {
            var _client_project_list$;
            form.value.client_project_id = (_client_project_list$ = client_project_list.value[0]) === null || _client_project_list$ === void 0 ? void 0 : _client_project_list$.id;
          }
        }
      });
    };
    var showDialog = ref(false);
    //新增客户项目
    var addClientProject = () => {
      if (!form.value.company) {
        ElMessage({
          type: "error",
          message: "请先选择客户"
        });
        return;
      }
      showDialog.value = true;
    };
    var handle_close_client = type => {
      showDialog.value = false;
      getClientProjects(cur_client_id.value, type == "add" ? true : false);
    };
    var cur_client_id = ref(null);
    var get_select_item = val => {
      if (!val.client_level) {
        ElMessage({
          type: "error",
          message: "请先维护客户类型"
        });
        return;
      }
      is_show_dialog.value = false;
      // console.log("选择的客户==", val);
      if (data_type.value == "客户") {
        if (val.company != form.value.company) {
          var _val$user_info, _val$user_info2, _val$contact_person_i, _val$contact_person_i2;
          form.value.company = val.company;
          form.value.trade = val.trade;
          form.value.address = val.address;
          form.value.country = val.country;
          form.value.email = val.email;
          form.value.sale_user = ((_val$user_info = val.user_info) === null || _val$user_info === void 0 ? void 0 : _val$user_info.name) || "";
          form.value.userid = (_val$user_info2 = val.user_info) === null || _val$user_info2 === void 0 ? void 0 : _val$user_info2.id;
          client_contracts_list.value = val.client_users || [];
          form.value.client_level_number = val.client_level_number;
          form.value.client_level = val.client_level;
          form.value.client_type = val.client_type;
          form.client_type_number = val.client_type_number;
          form.value.name = ((_val$contact_person_i = val.contact_person_info) === null || _val$contact_person_i === void 0 ? void 0 : _val$contact_person_i.name) || "";
          form.value.phone = ((_val$contact_person_i2 = val.contact_person_info) === null || _val$contact_person_i2 === void 0 ? void 0 : _val$contact_person_i2.phone) || "";
          goods_list.value = [...val.class_ids_list];
          cate_list.value = [...val.class_ids_list];
          countIncome(goods_list.value);
          form.value.sales_dept_id = Number(val.dept_info.id) || "";
          form.value.sales_dept_name = val.dept_info.name;
          cur_client_id.value = val.id;
          getClientProjects(val.id, true);
        }
      }
    };
    /**
     * 选择联系人
     */
    watch(() => {
      return form.value.name;
    }, val => {
      if (client_contracts_list.value && client_contracts_list.value.length != 0) {
        var item = client_contracts_list.value && client_contracts_list.value.find(x => x.name == val);
        // console.log("选择的联系人是", item);
        // console.log("client_contract_list===", client_contracts_list.value);
        if (item) {
          form.value.phone = item.phone;
          form.value.clent_user_id = item.id;
        } else {
          form.value.clent_user_id = "";
          form.value.phone = "";
        }
      }
    });

    /**
     * 提交
     */
    var onSubmit = () => {
      ruleFormRef.value.validate(valid => {
        if (valid) {
          var _goods_list$value, _cate_list$value;
          console.log(valid);
          // form.value.salename = dic_data.sales_user_list.find(
          //   (x) => x.id == form.value.userid
          // )?.name;
          var obj = _.cloneDeep(form.value);
          obj.images = fileList.value.map(x => {
            if (x.response) {
              return {
                id: x.response.data.file_id,
                url: x.response.data.file_url
              };
            } else {
              return {
                id: x.id,
                url: x.url
              };
            }
          });
          obj.complete_time = Object.prototype.toString.call(obj.complete_time) == "[object Date]" ? obj.complete_time.toLocaleDateString() : obj.complete_time;
          var method = "post";
          if (props.id) {
            obj.id = props.id;
          }
          if ((_goods_list$value = goods_list.value) !== null && _goods_list$value !== void 0 && _goods_list$value.length) {
            obj.goods_ids = goods_list.value.map(x => {
              return x.id;
            }).join(",");
          } else {
            obj.goods_ids = "";
          }
          if ((_cate_list$value = cate_list.value) !== null && _cate_list$value !== void 0 && _cate_list$value.length) {
            obj.class_ids = cate_list.value.map(x => {
              return x.id;
            }).join(",");
          } else {
            obj.class_ids = "";
          }
          delete obj.sale_user;
          set_clue(obj, method).then(res => {
            if (res.code == 200) {
              // disStore.get_clue_count();
              ElMessage({
                type: "success",
                message: res.msg
              });
              dialogVisible.value = false;
              emit("onSetSuccess", obj.thread_status);
            } else {
              ElMessage({
                type: "warning",
                message: res.msg
              });
            }
          });
        }
      });
    };

    /**
     * 数据字典
     */
    var dic_data = reactive({
      sales_area_list: [],
      // 销售区域
      thread_status_list: [],
      // 线索状态
      source_list: [],
      // 线索来源
      trade_list: [],
      // 行业
      client_level: [],
      clientType_list: []
    });
    var visit_list = ref("");
    disStore.get_dic("线索状态").then(res => {
      dic_data.thread_status_list = res;
    });
    disStore.get_dic("线索来源").then(res => {
      dic_data.source_list = res;
    });
    disStore.get_dic("行业").then(res => {
      dic_data.trade_list = res;
    });
    disStore.get_dic("客户分类--erp").then(res => {
      dic_data.clientType_list = res;
    });
    disStore.get_dic("客户种类-销售订单").then(res => {
      dic_data.client_level = res;
    });
    /**
     * 销售区域
     */
    var get_sale_area = function get_sale_area(id) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      if (!id) {
        return false;
      }
      sales_area({
        interface: "get_user_data_auth_detail",
        group_type: 1,
        userid: id,
        page: 1,
        limit: 240
      }).then(res => {
        if (res.code == 200) {
          dic_data.sales_area_list = Object.values(res.data.list);
          if (cb) {
            cb();
          }
        }
      });
    };
    var price_input = val => {
      // console.log("val", val.target.value);
      if (form.value.income && form.value.income != "" && form.value.income != undefined) {
        form.value.income = val.target.value && Number(val.target.value).toFixed(2) || "";
      }
    };
    var invalid_reason_list = []; // 无效原因列表
    disStore.get_dic("无效线索原因").then(res => {
      invalid_reason_list = res;
    });
    return (_ctx, _cache) => {
      var _component_el_option = _resolveComponent("el-option");
      var _component_el_select = _resolveComponent("el-select");
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_col = _resolveComponent("el-col");
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_InfoFilled = _resolveComponent("InfoFilled");
      var _component_el_icon = _resolveComponent("el-icon");
      var _component_el_tooltip = _resolveComponent("el-tooltip");
      var _component_el_row = _resolveComponent("el-row");
      var _component_el_date_picker = _resolveComponent("el-date-picker");
      var _component_Plus = _resolveComponent("Plus");
      var _component_el_upload = _resolveComponent("el-upload");
      var _component_el_dialog = _resolveComponent("el-dialog");
      var _component_el_form = _resolveComponent("el-form");
      var _component_good_list_table = _resolveComponent("good-list-table");
      var _component_select_data = _resolveComponent("select-data");
      var _component_client_project_dialog = _resolveComponent("client-project-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => dialogVisible.value = $event),
        title: __props.id ? '编辑线索' : '新增线索',
        style: {
          "width": "80%"
        }
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[26] || (_cache[26] = $event => dialogVisible.value = false)
        }, {
          default: _withCtx(() => _cache[54] || (_cache[54] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onSubmit,
          color: "#248f83"
        }, {
          default: _withCtx(() => _cache[55] || (_cache[55] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: _unref(form),
          "label-position": "right",
          rules: rules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "线索状态",
                prop: "thread_status"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).thread_status,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).thread_status = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.thread_status_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _unref(form).thread_status == '无效线索' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_cache[30] || (_cache[30] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "无效原因",
                prop: "invalid_reason"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).invalid_reason,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).invalid_reason = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invalid_reason_list), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[32] || (_cache[32] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户",
                prop: "company"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
                  modelValue: _unref(form).company,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(form).company = $event),
                  autocomplete: "off",
                  disabled: "",
                  format: "YYYY-MM-DD HH:mm",
                  "value-format": "YYYY-MM-DD HH:mm",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]), _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = $event => select_data('客户')),
                  color: "#248f83"
                }, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [_createTextVNode("选择")])),
                  _: 1
                })])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[33] || (_cache[33] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户类型",
                prop: "client_level"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[4] || (_cache[4] = $event => changeSelect($event, 'client_level')),
                  modelValue: _unref(form).client_level,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(form).client_level = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.client_level, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户分类"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  onChange: _cache[6] || (_cache[6] = $event => changeSelect($event, 'client_type_number')),
                  modelValue: _unref(form).client_type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => _unref(form).client_type = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.clientType_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), cur_client_id.value ? (_openBlock(), _createBlock(_component_el_col, {
              key: 1,
              span: 12
            }, {
              default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "客户项目",
                prop: "company"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select, {
                  modelValue: _unref(form).client_project_id,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _unref(form).client_project_id = $event),
                  filterable: "",
                  placeholder: "请选择客户项目",
                  style: {
                    "width": "90%"
                  },
                  "value-key": "FNumber"
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_project_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.project,
                      value: item.id
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"]), _createElementVNode("span", {
                  class: "client_add iconfont icon-a-zengjiatianjiajiahaoduo",
                  onClick: addClientProject
                })])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[36] || (_cache[36] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售区域",
                prop: "sales_dept_id"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).sales_dept_name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _unref(form).sales_dept_name = $event),
                  disabled: true
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[37] || (_cache[37] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "销售员",
                prop: "sale_user"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).sale_user,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => _unref(form).sale_user = $event),
                  autocomplete: "off",
                  disabled: ""
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "联系人",
                prop: "name"
              }, {
                default: _withCtx(() => [_unref(form).from_road == 'scy' ? (_openBlock(), _createBlock(_component_el_input, {
                  key: 0,
                  modelValue: _unref(form).name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => _unref(form).name = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])) : (_openBlock(), _createBlock(_component_el_select, {
                  key: 1,
                  modelValue: _unref(form).name,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _unref(form).name = $event),
                  class: "m-2",
                  placeholder: "",
                  filterable: "",
                  "allow-create": "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(client_contracts_list.value, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"]))]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[39] || (_cache[39] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "手机号码",
                prop: "phone"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).phone,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => _unref(form).phone = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[40] || (_cache[40] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "预计收入"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).income,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => _unref(form).income = $event),
                  autocomplete: "off",
                  onBlur: price_input,
                  oninput: "value=value.replace(/[^0-9.]/g,'')"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[43] || (_cache[43] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "成单率",
                prop: "completion_rate",
                required: _unref(hasValue)
              }, {
                label: _withCtx(() => [_createVNode(_component_el_tooltip, {
                  class: "box-item",
                  effect: "dark",
                  content: "",
                  placement: "bottom-start"
                }, {
                  content: _withCtx(() => _cache[41] || (_cache[41] = [_createTextVNode(" 成单率<30% 机会很小；30-60% 客户没有明显倾向性，机会均等；"), _createElementVNode("br", null, null, -1), _createTextVNode("60-90% 客户倾向百林科，>90% 确定采购百林科")])),
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_cache[42] || (_cache[42] = _createElementVNode("span", null, "成单率", -1)), _createVNode(_component_el_icon, {
                    class: "icon"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
                    _: 1
                  })])]),
                  _: 1
                })]),
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).completion_rate,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => _unref(form).completion_rate = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderRateList), item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.label,
                      label: item.label,
                      value: item.label
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              }, 8, ["required"])]),
              _: 1
            })]),
            _: 1
          }), _cache[53] || (_cache[53] = _createElementVNode("div", {
            class: "title"
          }, "选填选项", -1)), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_unref(form).thread_status != '无效线索' ? (_openBlock(), _createBlock(_component_el_col, {
              key: 0,
              span: 12
            }, {
              default: _withCtx(() => [_cache[44] || (_cache[44] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "预计完成时间"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                  modelValue: _unref(form).complete_time,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => _unref(form).complete_time = $event),
                  type: "date",
                  placeholder: "请选择",
                  style: {
                    "width": "100%"
                  }
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })) : _createCommentVNode("", true), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[45] || (_cache[45] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "线索来源"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).source,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => _unref(form).source = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.source_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[46] || (_cache[46] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "行业"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_select, {
                  modelValue: _unref(form).trade,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => _unref(form).trade = $event),
                  class: "m-2",
                  placeholder: "",
                  style: {
                    "width": "100%"
                  }
                }, {
                  default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dic_data.trade_list, item => {
                    return _openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.full_name,
                      value: item.full_name
                    }, null, 8, ["label", "value"]);
                  }), 128))]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[47] || (_cache[47] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "活动名称"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).activity_name,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => _unref(form).activity_name = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[48] || (_cache[48] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "邮箱"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).email,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => _unref(form).email = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[49] || (_cache[49] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "国家"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).country,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => _unref(form).country = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            }), _createVNode(_component_el_col, {
              span: 12
            }, {
              default: _withCtx(() => [_cache[50] || (_cache[50] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "地址"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  modelValue: _unref(form).address,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => _unref(form).address = $event),
                  autocomplete: "off"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[51] || (_cache[51] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "上传图片"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_upload, {
                  "file-list": fileList.value,
                  "onUpdate:fileList": _cache[23] || (_cache[23] = $event => fileList.value = $event),
                  action: action,
                  headers: headers,
                  data: {
                    content_type: 1
                  },
                  "list-type": "picture-card",
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove,
                  "on-success": handleAvatarSuccess,
                  "before-upload": beforeAvatarUpload
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [_createVNode(_component_Plus)]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["file-list"]), _createVNode(_component_el_dialog, {
                  modelValue: dialogVisible_img.value,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => dialogVisible_img.value = $event)
                }, {
                  default: _withCtx(() => [_createElementVNode("img", {
                    "w-full": "",
                    src: dialogImageUrl.value,
                    alt: "Preview Image"
                  }, null, 8, _hoisted_5)]),
                  _: 1
                }, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_row, {
            gutter: 20
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 24
            }, {
              default: _withCtx(() => [_cache[52] || (_cache[52] = _createElementVNode("div", {
                class: "grid-content ep-bg-purple"
              }, null, -1)), _createVNode(_component_el_form_item, {
                label: "备注"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: _unref(form).remark,
                  "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => _unref(form).remark = $event),
                  rows: "4"
                }, null, 8, ["modelValue"])]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"]), _createElementVNode("div", null, [_createVNode(_component_good_list_table, {
          goods: goods_list.value,
          onChange_goods: handle_goods
        }, null, 8, ["goods"])])]),
        _: 1
      }, 8, ["modelValue", "title"]), _createVNode(_component_select_data, {
        onClose: _cache[28] || (_cache[28] = $event => is_show_dialog.value = false),
        isShow: is_show_dialog.value,
        data_type: data_type.value,
        key_word: key_word.value,
        dialog: "",
        onOnSelectItem: get_select_item
      }, null, 8, ["isShow", "data_type", "key_word"]), showDialog.value ? (_openBlock(), _createBlock(_component_client_project_dialog, {
        key: 0,
        isShow: showDialog.value,
        onOnClose: handle_close_client,
        id: cur_client_id.value
      }, null, 8, ["isShow", "id"])) : _createCommentVNode("", true)]);
    };
  }
};